//@ts-check
import React from 'react';
import { Swiper } from 'swiper/react';
import { CustomContainer } from '../general';

/**
 * @type {React.FC<{children:React.ReactNode,allowTouchMove?:boolean}>}
 */
export const CardsCarouselContainer = ({ children, allowTouchMove = true }) => {
  return (
    <CustomContainer size="full-width" className="relative" alignCenter={true}>
      <CustomContainer
        size="ensino-institucional"
        className="relative xl:static [&_div.swiper-button-prev]:!w-12 [&_div.swiper-button-next]:!w-12 md:[&_div.swiper-button-prev]:!w-8 md:[&_div.swiper-button-next]:!w-8"
        alignCenter={true}>
        <Swiper
          allowTouchMove={allowTouchMove}
          navigation={true}
          slidesPerView={'auto'}
          breakpoints={{
            0: {
              spaceBetween: 0,
            },
            768: {
              spaceBetween: 10,
            },
            1280: {
              spaceBetween: 20,
            },
          }}
          containerModifierClass="xl:!overflow-visible overflow-hidden"
        >
          {children}
        </Swiper>
      </CustomContainer>
    </CustomContainer>
  );
};

